module.exports = __webpack_public_path__ + "static/media/CyberAidBackground.09946f5e.png";